var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJyupyter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 70,
    height: 70,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "70AWaG9FpYs2yn8LzRfdUa_J0SgMWzAxqFj_gr1",
    x1: 17.151,
    x2: 29.996,
    y1: 8.498,
    y2: 37.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f09701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e36001"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#70AWaG9FpYs2yn8LzRfdUa_J0SgMWzAxqFj_gr1)",
    d: "M8.108,18.006C10.534,11.579,16.724,7,24,7c7.276,0,13.466,4.579,15.892,11.006 C36.653,14.6,30.757,12.313,24,12.313C17.243,12.313,11.347,14.6,8.108,18.006z M24,35.688c-6.757,0-12.653-2.287-15.892-5.693 C10.534,36.421,16.724,41,24,41c7.276,0,13.466-4.579,15.892-11.006C36.653,33.4,30.757,35.688,24,35.688z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "70AWaG9FpYs2yn8LzRfdUb_J0SgMWzAxqFj_gr2",
    x1: 1.319,
    x2: 25.671,
    y1: 44.651,
    y2: 1.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#70AWaG9FpYs2yn8LzRfdUb_J0SgMWzAxqFj_gr2)",
    d: "M39.512,4.744c0,1.515-1.228,2.744-2.744,2.744s-2.744-1.228-2.744-2.744S35.253,2,36.768,2 S39.512,3.228,39.512,4.744z M10.976,40.415c-1.818,0-3.293,1.474-3.293,3.293c0,1.818,1.474,3.293,3.293,3.293 s3.293-1.474,3.293-3.293C14.268,41.889,12.794,40.415,10.976,40.415z M7.683,6.39c-1.212,0-2.195,0.983-2.195,2.195 s0.983,2.195,2.195,2.195s2.195-0.983,2.195-2.195S8.895,6.39,7.683,6.39z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJyupyter);
export default __webpack_public_path__ + "static/media/jyupyter.4550cb5234cfec80cc44557c4efea8bf.svg";
export { ForwardRef as ReactComponent };